























import { Component, Prop, Vue } from 'vue-property-decorator';
import Preloader from '../../utils/preloader';


const AVATARS = ['sherlock', 'watson', 'poirot', 'marple', 'mulder', 'scully', 'olivia', 'walter', 'george', 'nico'];


@Component({
    components: {

    },
})
export default class AvatarSelectorVue extends Vue {

    @Prop({default: true})
    private enabled!: boolean;


    avatars: string[] = [];
    current: number = 0;

    mounted(){

        this.avatars = AVATARS.map(a => require(`@/assets/avatars/${a}_256.png`) );
        this.current = Math.floor((Math.random() * this.avatars.length));
        this.$emit('input', AVATARS[this.current]);

    }

    get avatar(){
        return this.avatars[this.current];
    }

    prev(){
        const num = this.avatars.length;
        this.current = (this.current+num-1) % num;
        this.$emit('input', AVATARS[this.current]);
    }

    next(){
        const num = this.avatars.length;
        this.current = (this.current+1) % num;
        this.$emit('input', AVATARS[this.current]);
    }

}

